/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_Not_TrackableInputs */

const en_error_inbound_not_trackable = /** @type {(inputs: Error_Inbound_Not_TrackableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The tracking of this inbound can no longer be written: it was not sent yet, or the warehouse has already received it. Reload the page to see where it is.`)
};

/**
* | output |
* | --- |
* | "The tracking of this inbound can no longer be written: it was not sent yet, or the warehouse has already received it. Reload the page to see where it is." |
*
* @param {Error_Inbound_Not_TrackableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_not_trackable = /** @type {((inputs?: Error_Inbound_Not_TrackableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_Not_TrackableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_not_trackable(inputs)
});